import { useCallback, useEffect } from "react";
import { useStatefulRef } from "../../../../functional/useStatefulRef";
export var XSSOState;
(function (XSSOState) {
    XSSOState["Init"] = "init";
    XSSOState["Set"] = "set";
    XSSOState["Unchanged"] = "unchanged";
    XSSOState["PollAborted"] = "poll_aborted";
    XSSOState["LoginRequired"] = "login_required";
    XSSOState["Limited"] = "limited";
    XSSOState["TooSoon"] = "too_soon";
})(XSSOState || (XSSOState = {}));
export const useXSSO = () => {
    const { state, ref, setValues } = useStatefulRef(XSSOState.Init);
    useEffect(() => {
        console.log("Running initial poll");
        const clearPollXsso = setTimeout(() => {
            if (ref.current === XSSOState.Init) {
                clearInterval(pollXsso);
                console.warn("XSSO poll aborted - giving up and defaulting to aborted");
                setValues(XSSOState.PollAborted);
            }
        }, 3000);
        const pollXsso = setInterval(() => {
            const xsso = window?.xsso;
            if (xsso) {
                console.log("XSSO found - clearing poll");
                clearInterval(pollXsso);
                xsso.onEvent((event) => {
                    if (Object.values(XSSOState).includes(event)) {
                        setValues(event);
                    }
                });
            }
        }, 100);
        const clearTimers = () => {
            clearInterval(pollXsso);
            clearTimeout(clearPollXsso);
        };
        return () => clearTimers();
    }, [ref, setValues]);
    const reauth = useCallback(() => window.xsso?.attemptLoginPromptNone(), []);
    return { reauth, xssoState: state };
};
//# sourceMappingURL=useXSSO.js.map